import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Stats from "./components/Stats";
import Services from "./components/ServicesGrid";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

// Main pages
import Blefaroplastia from "./pages/Blefaroplastia";
import LiftingFacial from "./pages/LiftingFacial";
import Endolifting from "./pages/Endolifting";
import CirugiaMamas from "./pages/CirugiaMamas";
import CirugiaAbdomen from "./pages/CirugiaAbdomen";
import GinecoEstetica from "./pages/GinecoEstetica";
import OjerasBolsas from "./pages/OjerasBolsas";
import CirugiaPostbariatrica from "./pages/CirugiaPostbariatrica";
import MapaSitio from "./pages/MapaSitio";
import Rinomodelacion from "./pages/Rinomodelacion";
import ClinicaAlameda from "./pages/ClinicaAlameda";
import DondeAtendemos from "./pages/DondeAtendemos";

// New Hub Pages
import CirugiaFacial from "./pages/CirugiaFacial";
import CirugiaCorporal from "./pages/CirugiaCorporal";
import MedicinaEstetica from "./pages/MedicinaEstetica";
import CirugiaReparadora from "./pages/CirugiaReparadora";
import ElDoctor from "./pages/ElDoctor";
import Acreditaciones from "./pages/Acreditaciones";
import Contacto from "./pages/Contacto";

// CRM / Admin (accessed only through /clinica/portal after auth)
import ClinicaLogin from "./components/ClinicaLogin";
import ClinicaPortal from "./components/ClinicaPortal";

// Guides
import GuiaCuidadosBlefaroplastia from "./pages/GuiaCuidadosBlefaroplastia";
import GuiasRecursos from "./pages/GuiasRecursos";

// New Treatment Pages
import Rinoplastia from "./pages/Rinoplastia";
import Otoplastia from "./pages/Otoplastia";
import Ginecomastia from "./pages/Ginecomastia";
import Liposuccion from "./pages/Liposuccion";
import Papada from "./pages/Papada";
import ElevacionCejas from "./pages/ElevacionCejas";
import ArmonizacionFacial from "./pages/ArmonizacionFacial";
import OjerasSinCirugia from "./pages/OjerasSinCirugia";
import MedicinaIntegrativa from "./pages/MedicinaIntegrativa";
import CirugiaDermatologica from "./pages/CirugiaDermatologica";
import CirugiasSecundarias from "./pages/CirugiasSecundarias";
import SegundaOpinion from "./pages/SegundaOpinion";
import PeritacionMedica from "./pages/PeritacionMedica";
import Braquioplastia from "./pages/Braquioplastia";

// Recovery Center
import Preparacion from "./pages/Preparacion";
import Recuperacion from "./pages/Recuperacion";
import SkinHealth from "./pages/SkinHealth";

// Rinomodelacion subpages
import QueEs from "./pages/rinomodelacion/QueEs";
import TecnicaMateriales from "./pages/rinomodelacion/TecnicaMateriales";
import Resultados from "./pages/rinomodelacion/Resultados";
import Doctor from "./pages/rinomodelacion/Doctor";
import FAQ from "./pages/rinomodelacion/FAQ";
import ContactoRino from "./pages/rinomodelacion/Contacto";
import ComoLlegar from "./pages/rinomodelacion/ComoLlegar";
import Curriculum from "./pages/rinomodelacion/Curriculum";
import Prensa from "./pages/rinomodelacion/Prensa";
import Ponencias from "./pages/rinomodelacion/Ponencias";
import Marbella from "./pages/rinomodelacion/Marbella";

// FAQ Pages
import { 
  FAQProcedimiento, 
  FAQEstudioImagen, 
  FAQPrecios, 
  FAQMateriales, 
  FAQDiferencias, 
  FAQDuracion 
} from "./pages/rinomodelacion/FAQPages";

// Resultados Pages
import { 
  CorreccionRinoplastia, 
  Ejemplo2, 
  Ejemplo3, 
  Ejemplo4, 
  Perfiloplastia, 
  Ejemplo6, 
  Ejemplo7, 
  Ejemplo8,
  Ejemplo9 
} from "./pages/rinomodelacion/ResultadoDetalle";

import { Toaster } from "./components/ui/toaster";
import "./App.css";

const Home = () => {
  return (
    <div className="min-h-screen bg-ivory">
      <Header />
      <Hero />
      <About />
      <Services />
      <Stats />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Main pages */}
          <Route path="/" element={<Home />} />
          
          {/* Hub Pages */}
          <Route path="/cirugia-facial" element={<CirugiaFacial />} />
          <Route path="/cirugia-corporal" element={<CirugiaCorporal />} />
          <Route path="/medicina-estetica" element={<MedicinaEstetica />} />
          <Route path="/cirugia-reparadora" element={<CirugiaReparadora />} />
          <Route path="/el-doctor" element={<ElDoctor />} />
          <Route path="/el-doctor/acreditaciones" element={<Acreditaciones />} />
          <Route path="/contacto" element={<Contacto />} />
          
          {/* Cirugía Facial */}
          <Route path="/blefaroplastia" element={<Blefaroplastia />} />
          <Route path="/lifting-facial" element={<LiftingFacial />} />
          <Route path="/ojeras-bolsas" element={<OjerasBolsas />} />
          <Route path="/rinoplastia" element={<Rinoplastia />} />
          <Route path="/otoplastia" element={<Otoplastia />} />
          
          {/* Cirugía Corporal */}
          <Route path="/cirugia-mamas" element={<CirugiaMamas />} />
          <Route path="/ginecomastia" element={<Ginecomastia />} />
          <Route path="/cirugia-abdomen" element={<CirugiaAbdomen />} />
          <Route path="/abdominoplastia" element={<CirugiaAbdomen />} />
          <Route path="/abdomen" element={<CirugiaAbdomen />} />
          <Route path="/cirugia-postbariatrica" element={<CirugiaPostbariatrica />} />
          <Route path="/liposuccion" element={<Liposuccion />} />
          <Route path="/braquioplastia" element={<Braquioplastia />} />
          <Route path="/gineco-estetica" element={<GinecoEstetica />} />
          
          {/* Medicina Estética */}
          <Route path="/rinomodelacion" element={<Rinomodelacion />} />
          <Route path="/endolifting" element={<Endolifting />} />
          <Route path="/papada" element={<Papada />} />
          <Route path="/elevacion-cejas" element={<ElevacionCejas />} />
          <Route path="/armonizacion-facial" element={<ArmonizacionFacial />} />
          <Route path="/ojeras-sin-cirugia" element={<OjerasSinCirugia />} />
          <Route path="/medicina-integrativa" element={<MedicinaIntegrativa />} />
          
          {/* Cirugía Reparadora y Pericial */}
          <Route path="/cirugia-dermatologica" element={<CirugiaDermatologica />} />
          <Route path="/cirugias-secundarias" element={<CirugiasSecundarias />} />

          {/* Recovery Center */}
          <Route path="/preparacion" element={<Preparacion />} />
          <Route path="/recuperacion" element={<Recuperacion />} />
          <Route path="/skin-health" element={<SkinHealth />} />
          <Route path="/segunda-opinion" element={<SegundaOpinion />} />
          <Route path="/peritacion-medica" element={<PeritacionMedica />} />
          
          {/* Clínica */}
          <Route path="/clinica-alameda" element={<ClinicaAlameda />} />
          <Route path="/donde-atendemos" element={<DondeAtendemos />} />
          <Route path="/mapa-sitio" element={<MapaSitio />} />
          
          {/* CRM / Admin - only through authenticated portal */}
          <Route path="/clinica/login" element={<ClinicaLogin />} />
          <Route path="/clinica/portal" element={<ClinicaPortal />} />
          
          {/* Portal Clínicas */}
          <Route path="/portal-clinicas" element={<ClinicaLogin />} />
          <Route path="/clinica/login" element={<ClinicaLogin />} />
          <Route path="/clinica/portal" element={<ClinicaPortal />} />
          
          {/* Guías */}
          <Route path="/guias-recursos" element={<GuiasRecursos />} />
          <Route path="/guia-cuidados-blefaroplastia" element={<GuiaCuidadosBlefaroplastia />} />
          <Route path="/blefaroplastia/guia-cuidados" element={<GuiaCuidadosBlefaroplastia />} />
          
          {/* Rinomodelacion - Main subpages */}
          <Route path="/rinomodelacion/que-es" element={<QueEs />} />
          <Route path="/rinomodelacion/tecnica-materiales" element={<TecnicaMateriales />} />
          <Route path="/rinomodelacion/resultados" element={<Resultados />} />
          <Route path="/rinomodelacion/doctor" element={<Doctor />} />
          <Route path="/rinomodelacion/faq" element={<FAQ />} />
          <Route path="/rinomodelacion/contacto" element={<ContactoRino />} />
          
          {/* Rinomodelacion - Resultados subpages */}
          <Route path="/rinomodelacion/resultados/correccion-rinoplastia" element={<CorreccionRinoplastia />} />
          <Route path="/rinomodelacion/resultados/ejemplo-2" element={<Ejemplo2 />} />
          <Route path="/rinomodelacion/resultados/ejemplo-3" element={<Ejemplo3 />} />
          <Route path="/rinomodelacion/resultados/ejemplo-4" element={<Ejemplo4 />} />
          <Route path="/rinomodelacion/resultados/perfiloplastia" element={<Perfiloplastia />} />
          <Route path="/rinomodelacion/resultados/ejemplo-6" element={<Ejemplo6 />} />
          <Route path="/rinomodelacion/resultados/ejemplo-7" element={<Ejemplo7 />} />
          <Route path="/rinomodelacion/resultados/ejemplo-8" element={<Ejemplo8 />} />
          <Route path="/rinomodelacion/resultados/ejemplo-9" element={<Ejemplo9 />} />
          
          {/* Rinomodelacion - Doctor subpages */}
          <Route path="/rinomodelacion/doctor/curriculum" element={<Curriculum />} />
          <Route path="/rinomodelacion/doctor/prensa" element={<Prensa />} />
          <Route path="/rinomodelacion/doctor/ponencias" element={<Ponencias />} />
          
          {/* Rinomodelacion - FAQ subpages */}
          <Route path="/rinomodelacion/faq/procedimiento" element={<FAQProcedimiento />} />
          <Route path="/rinomodelacion/faq/estudio-imagen" element={<FAQEstudioImagen />} />
          <Route path="/rinomodelacion/faq/precios" element={<FAQPrecios />} />
          <Route path="/rinomodelacion/faq/materiales" element={<FAQMateriales />} />
          <Route path="/rinomodelacion/faq/diferencias" element={<FAQDiferencias />} />
          <Route path="/rinomodelacion/faq/duracion" element={<FAQDuracion />} />
          
          {/* Rinomodelacion - Contacto subpages */}
          <Route path="/rinomodelacion/contacto/como-llegar" element={<ComoLlegar />} />
          <Route path="/rinomodelacion/contacto/marbella" element={<Marbella />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
